angular.module('am4').service('formatDistanceService', function(CONVERSIONS, $translate, $filter) {

    var fullUnits = {
            metric: 'KILOMETERS',
            imperial: 'MILES'
        },
        abrevUnits = {
            metric: 'KM',
            imperial: 'MI'
        },
        fullPhrase = {
            metric: 'N_KILOMETERS',
            imperial: 'N_MILES'
        },
        abrevPhrase = {
            metric: 'N_KM',
            imperial: 'N_MI'
        },
        conversion = {
            stepsTofloors: function(steps) { return steps / CONVERSIONS.STEPS_PER_FLOOR; },
            miles100ToKm: function(m100) { return CONVERSIONS.KM_PER_MILE * m100 / CONVERSIONS.MILES_100_PER_MILE; },
            miles100ToMiles: function(m100) { return m100/ CONVERSIONS.MILES_100_PER_MILE; }
        },
        numberFilter = $filter('number');

    return {

        /**
         * @funtion formatDistance
         * @description Extends an object with two properties, totalDistance, and distanceUnit
         * which describe that objects distance and preferred unit.
         * @param  {Object}  distObj           Object to be extended with totalDistance and distanceUnit
         * @param  {String}  unitPreference    User's unit preference
         * @param  {String}  modality          Machine modality the distance is for, determines steps vs mi/km
         * @param  {Boolean} longUnits         True for full distance units, false for abbreviations
         * @param  {String}  steps             Param name for steps in distObj, defaults to 'accumulated_steps'
         * @param  {String}  miles100          Param name for miles_100 in distObj, defaults to 'accumulated_miles_100'
         * @return {Object}                    Updated distance object
         */
        formatDistance: function(distObj, unitPreference, _modality, longUnits, _steps, _miles100) {
            var unit = longUnits ? fullUnits[unitPreference] : abrevUnits[unitPreference],
                phrase = longUnits ? fullPhrase[unitPreference] : abrevPhrase[unitPreference],
                normalDistConversion = unitPreference === 'metric' ? conversion.miles100ToKm : conversion.miles100ToMiles,
                steps = _steps || 'accumulated_steps',
                miles100 = _miles100 || 'accumulated_miles_100',
                modality = _modality;

            // Treat machines with no modality, but WITH steps as steppers
            if (!_modality && +distObj[steps]) {
                modality = 'stepper';
            }

            switch (modality) {
            case 'climbmill':
            case 'stepper':
                // See if we're a steps modality without any steps
                if (!+distObj[steps]) {
                    // if a stepper doesn't have steps, it is reporting floors in the
                    // accumulated_miles_100 property
                    distObj.totalDistance = +distObj[miles100];
                } else {
                    distObj.totalDistance = conversion.stepsTofloors(+distObj[steps]);
                }
                distObj.distanceUnit = 'FLOORS';
                distObj.distancePhrase = 'N_FLOORS';
                break;
            default:
                distObj.totalDistance = normalDistConversion(+distObj[miles100]);
                distObj.distanceUnit = unit;
                distObj.distancePhrase = phrase;
                break;
            }

            distObj.timeTranslated = distObj.accumulated_time_delta === null ?
                $translate.instant('NA') :
                $translate.instant('N_HOURS', { n: numberFilter(distObj.accumulated_time_delta / 60 / 60, 0) });

            distObj.distanceTranslated = !distObj.totalDistance && isNaN(distObj.totalDistance) ?
                $translate.instant('NA') :
                $translate.instant(distObj.distancePhrase, { n: numberFilter(distObj.totalDistance, 0) });

            return distObj;
        },

        /**
         * @funtion formatDistanceDelta
         * @description Extends an object with two properties, totalDistance, and distanceUnit
         * which describe that objects distance and preferred unit
         *
         * Accepts `distObj` with 'accumulated_steps_delta' and 'accumulated_miles_100_delta' properties
         *
         * @param  {String}  unit preference   User's unit preference
         * @param  {Object}  distObj           Object to be extended with totalDistance, distancePhrase, and distanceUnit
         * @param  {Boolean} longUnits         True for full distance units, false for abbreviations
         * @return {Object}                    Updated distance object
         */
        formatDistanceDelta: function(distObj, unitPreference, modality, longUnits) {
            return this.formatDistance(distObj, unitPreference, modality, longUnits, 'accumulated_steps_delta', 'accumulated_miles_100_delta');
        },

        /**
         * @funtion formatDistanceTotal
         * @description Extends an object with two properties, totalDistance, and distanceUnit
         * which describe that objects distance and preferred unit
         *
         * Accepts `distObj` with 'total_steps' and 'total_miles_100' properties
         *
         * @param  {String}  unit preference   User's unit preference
         * @param  {Object}  distObj           Object to be extended with totalDistance, distanceUnit and distanceUnit
         * @param  {Boolean} longUnits         True for full distance units, false for abbreviations
         * @return {Object}                    Updated distance object
         */
        formatDistanceTotal: function(distObj, unitPreference, modality, longUnits) {
            return this.formatDistance(distObj, unitPreference, modality, longUnits, 'total_steps', 'total_miles_100');
        }
    };
});



// WEBPACK FOOTER //
// ./src/app/services/formatDistance.js